export default __webpack_public_path__ + "static/media/message.4f13c9f2.svg";